import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import "./App.css";
import "./Responsive.css";

// Components
import Header from "./Components/Header";

// Pages
import Home from "./Pages/Home";
import ProfilePage from "./Pages/ProfilePage";
import { user } from "./constants";
import CoinDetails from "./Pages/CoinDetails";
import Advanced from "./Components/Advanced";

function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/profile"
          element={user ? <ProfilePage type={"own"} /> : <Navigate to={"/"} />}
        />
        <Route path="/profile/:id" element={<ProfilePage type={"other"} />} />
        <Route path="/coin-details" element={<CoinDetails/>}/>
        <Route path="/advance" element={<Advanced/>}></Route>
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
